import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import { type PaginatedPeriodicityListList } from '../../../../../../src/types/PaginatedPeriodicityListList';
export {
  type CustomerPeriodicity,
  CustomerPeriodicityTypes,
  type PaginatedPeriodicityListList,
} from '../../../../../../src/types/PaginatedPeriodicityListList';

export async function getCustomerPeriodicities() {
  const query = new URLSearchParams();

  // maintain a high limit so query invalidation and refetching always ensures any recently PATCHed values
  // are reflected correctly in the UI
  query.set('limit', '10000');

  return await send<PaginatedPeriodicityListList>({
    path: `/api/v2/customers/self/periodicities/`,
    method: 'GET',
    query,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
